module.exports = __webpack_public_path__ + "img/audit.8a5b7d7e.png";